/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddGreenMachineStaffStacksInput = {|
  greenMachineSessionId: string,
  staffStackIds: $ReadOnlyArray<?string>,
  clientMutationId?: ?string,
|};
export type GCStaffStacksListMutationVariables = {|
  input: AddGreenMachineStaffStacksInput
|};
export type GCStaffStacksListMutationResponse = {|
  +addGreenMachineStaffStacks: ?{|
    +success: ?boolean
  |}
|};
export type GCStaffStacksListMutation = {|
  variables: GCStaffStacksListMutationVariables,
  response: GCStaffStacksListMutationResponse,
|};
*/


/*
mutation GCStaffStacksListMutation(
  $input: AddGreenMachineStaffStacksInput!
) {
  addGreenMachineStaffStacks(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddGreenMachineStaffStacksPayload",
    "kind": "LinkedField",
    "name": "addGreenMachineStaffStacks",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GCStaffStacksListMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GCStaffStacksListMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3eb49d6bf965ad1b6ed3d0084b6dfcb8",
    "id": null,
    "metadata": {},
    "name": "GCStaffStacksListMutation",
    "operationKind": "mutation",
    "text": "mutation GCStaffStacksListMutation(\n  $input: AddGreenMachineStaffStacksInput!\n) {\n  addGreenMachineStaffStacks(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '852b3f19156d3f0b0330854c91f0ef0a';

module.exports = node;
